import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { NavService } from '@projects/shared/src/app/services/nav.service';
import { ToastService } from '@projects/shared/src/app/services/toast/toast.service';
import { BugReportService } from './bug-report.service';
import { animate, style, transition, trigger } from '@angular/animations';
@Component({
  selector: 'bug-report',
  templateUrl: './bug-report.component.html',
  styleUrls: ['./bug-report.component.scss'],
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('400ms', style({ transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)' }),
        animate('400ms', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
})
export class BugReportComponent implements OnInit {
  constructor(
    private _elementRef: ElementRef,
    public navService: NavService,
    public bugReportService: BugReportService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {}

  submitBugReport() {
    this.bugReportService.bugReportForm.markAllAsTouched();
    if (this.bugReportService.bugReportForm.valid) {
      this.bugReportService.postBug();
    }
  }
  onFilesSelect(e: any) {
    if (!e.target.files || e.target.files.length === 0) {
      return;
    }
    let allowedExtensions = ['jpg', 'jpeg', 'png'];
    const filename = e.target.files[0].name;

    let parts = filename.split('.');
    const fileType = parts[parts.length - 1];
    const file = e.target.files[0];
    //fileType sucess
    if (allowedExtensions.includes(fileType)) {
      this.bugReportService.convertToBase64(file);
    } else {
      this.toastService.error(`File type not supported, use 'jpg', 'jpeg', 'png'`);
    }
  }
  closeForm() {
    this.bugReportService.clearForm();
    this.navService.toggleBugReportPane();
  }

  /**
   * For click outside of the calendar's container
   * @param event event object
   */
  @HostListener('document:click', ['$event'])
  outsideClick(event: any): void {
    if (!event.target) {
      return;
    }

    if (event.target.classList.contains('flecx_feedback_icon')) {
      return;
    }

    if (!this._elementRef.nativeElement.contains(event.target) && this.navService.getBugReportPane() === true) {
      this.navService.toggleBugReportPane();
    }
  }
}
